import {prefixUrl} from "../../utils/utilsData";
import _axios from "../../httpService";
import {toast} from "react-toastify";

export const getInitialData = async (urlData) => {

  const url = prefixUrl() + '/insurance' + urlData
  const res = await _axios.get(url);
  if (res.data.status) {
    return res.data.data
  } else {
    toast.error(res.data.message)
    return {
      // agentRLookUpId: 10,
      // bankRLookUpId: 44,
      // contractRLookUpId: 7,
      // customerRLookUpId: 5,
      // fundRLookUpId: 42,
      // insuranceTypeRLookUpId: 8,
      // organizationRLookUpId: 6,
      // tax:0,

    }
  }

}

export const optionArray = (arr = []) => arr?.map(row => row?.value)

export const validateInsuranceForm = (sendData) => {

  // بخش کلی
  if (sendData?.overallInfo?.insuranceNumber === '') {
    toast.error(' شماره بیمه نامه نباید خالی باشد. ')
    return false
  }
  if (sendData?.overallInfo?.contractType === '') {
    toast.error('نوع قرار داد را انتخاب کنید.')
    return false
  }
  if (sendData?.overallInfo?.insuranceTypeId === '') {
    toast.error('انتخاب نوع بیمه اجباری است. ')
    return false
  }
  if (sendData?.overallInfo?.insurancePrice === '') {
    toast.error('انتخاب ملبغ بیمه اجباری است. ')
    return false
  }
  if (sendData?.overallInfo?.paymentType === '') {
    toast.error('نوع پرداخت بیمه اجباری است. ')
    return false
  }







  // بخش مالی
  if (sendData?.financial?.hasAgent === '') {
    toast.error('آیا نماینده دارد؟  را مشخص کنید.')
    return false
  }
  if (sendData?.financial?.hasAgent === 'دارد' && sendData?.financial?.agentId==='') {
    toast.error('.کد نماینده را مشخص کنید')
    return false
  }
  if (sendData?.financial?.prePayment === '') {
    toast.error('مبلغ پیش پرداخت را وارد کنید.')
    return false
  }
  if (sendData?.financial?.receiveType === '') {
    toast.error('نوع دریافت پیش پرداخت را وارد کنید.')
    return false
  }
  if (sendData?.financial?.receiveType === 'نقدی' && sendData?.financial?.fundId==='') {
    toast.error('کد صندوق را انتخاب کنید.')
    return false
  }
  if (sendData?.financial?.receiveType === 'واریز به حساب' && sendData?.financial?.bankId==='') {
    toast.error('کد بانک را انتخاب کنید.')
    return false
  }

  if (sendData?.financial?.addedValue === '') {
    toast.error('لطفا ارزش افزوده را وارد کنید.')
    return false
  }


  return true

}